module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp3-ec2e05fabcebecf87b0e37441ed580d9.jpg";